import { EmptyState, IconButton, Skeleton, Tooltip, useTheme } from '~/design_system'

export const userRoles = {
  CANDIDATE: 1,
  EMPLOYER: 2,
  VENDOR: 3
}

// A color very close to blue.50 but with transparency
// so that it works well with the scroll shadows
export const UNREAD_BG_COLOR = 'rgba(124, 216, 255, .15);'

const Noop = ({ children }) => <>{children}</>

export function IconButtonWithTooltip({ 'aria-label': ariaLabel, label = ariaLabel, isDisabled, ...props }) {
  // Tooltips have a bug where they don't go away after mouseout of a disabled icon button
  // https://github.com/chakra-ui/chakra-ui/issues/500 fixed in v1
  const MaybeTooltip = isDisabled ? Noop : Tooltip
  return (
    <MaybeTooltip aria-label={ariaLabel} label={label} placement="top" hasArrow>
      <IconButton aria-label={ariaLabel} isDisabled={isDisabled} {...props}>
        {null}
      </IconButton>
    </MaybeTooltip>
  )
}

export function HeaderIconButton(props) {
  return (
    <IconButtonWithTooltip
      variant="ghost"
      size="md"
      color="gray.500"
      cursor="pointer"
      _hover={{ color: 'gray.700' }}
      position="relative"
      marginTop={-4}
      top="6px"
      {...props}
    />
  )
}

export function MutedSkeleton(props) {
  const { colors } = useTheme()
  return <Skeleton as="span" display="block" endColor={colors.gray[300]} {...props} />
}

// Sana-style empty state for home widgets: a small system icon above the text.
// Takes a ~/icons component, which renders Canvas glyphs behind the rebrand flag.
// Icon matches default body text color in both themes (gray.800 legacy, fg.default rebrand).
// (VNDLY-67060: trying this shape on home first before touching other sad states.)
export function WidgetEmptyState({ icon: Icon, children, ...props }) {
  return (
    <EmptyState {...props}>
      <Icon w={8} h={8} mb={2} color="var(--vndly-color-container-dark)" />
      {children}
    </EmptyState>
  )
}
